import { currencyFilter } from "@/filters/currency.filter";
import { BatchTransfer } from "@/interfaces/batchTransferManager";
import { Product } from "@/interfaces/product";
import { TableFieldType } from "helix-vue-components";

export const quoteTable: BatchTransfer.DataTable.TableDefs<
  BatchTransfer.Quote
> = {
  headers: [
    {
      label: "quote_number",
      value: "quote_number",
      fieldComponent: TableFieldType.string,
      sortable: true
    },
    {
      label: "timestamp",
      value: "timestamp",
      fieldComponent: TableFieldType.fnsDate
    },
    {
      label: "total",
      value: "total",
      fieldComponent: TableFieldType.string,
      sortable: true
    },
    {
      label: "user",
      value: "user",
      fieldComponent: TableFieldType.string
    },
    {
      label: "destination",
      value: "destination",
      fieldComponent: TableFieldType.string
    }
  ],
  sublistHeaders: [
    {
      label: "product",
      value: "product",
      fieldComponent: TableFieldType.string
    },
    {
      label: "quantity",
      value: "quantity",
      fieldComponent: TableFieldType.string
    },
    {
      label: "total",
      value: "total",
      fieldComponent: TableFieldType.string
    }
  ],
  rowActions: [
    {
      icon: "fal fa-print",
      action: BatchTransfer.DataTable.TABLEACTIONS.PRINT
    },
    {
      icon: "fal fa-pencil",
      action: BatchTransfer.DataTable.TABLEACTIONS.EDIT
    },
    { icon: "fal fa-trash", action: BatchTransfer.DataTable.TABLEACTIONS.VOID }
  ],
  mapper: (transfer: BatchTransfer.Quote) => {
    return {
      id: transfer.id ? transfer.id : "",
      quote_number: transfer.quote_number,
      timestamp: transfer.updated_at,
      total: currencyFilter(transfer.prices.total),
      user: transfer.user
        ? `${transfer.user.first_name} ${transfer.user.last_name}`
        : "",
      status: transfer.status,
      destination: transfer.destination ? transfer.destination!.name : "",
      items: transfer.items.map(item => {
        return {
          product: (item.product as Product).name,
          quantity: item.quantity,
          price: currencyFilter(item.prices.total)
        };
      })
    };
  }
};
